export default __webpack_public_path__ + "4254930b72827260bc44379db93ea3b6.svg";